export default "__VITE_ASSET__DBw5XemT__"